import styled from "styled-components";
import React, { useEffect, useState } from "react";

const Container = styled.span`
  padding: 0 2px;
  line-height: 1;
  font-weight: bold;
  display: inline-block;
  border-bottom: 2px solid #000;
  input {
    border: none;
    max-width: 40px;
    text-align: center;
    background: transparent;
    &:focus {
      outline: none;
    }
  }
`;

function Value({ max, min, name, onChange, value, unit }) {
  const [state, setState] = useState(value);

  useEffect(() => {
    setState(value);
  }, [value]);

  const handleBlur = () => {
    const nextValue = Math.min(Math.max(Number(state), min), max);
    onChange({ [name]: nextValue });
    setState(nextValue);
  };

  const handleChange = (evt) => {
    if (!/^\d*(\d\.\d{0,2})?$/.test(evt.target.value)) {
      return;
    }

    setState(evt.target.value);
  };

  return (
    <Container>
      {unit}
      <input
        name={name}
        aria-label={name}
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={state}
      />
    </Container>
  );
}

Value.defaultProps = {
  max: Number.MAX_SAFE_INTEGER,
  min: 0,
  unit: "",
  value: 0,
};

export { Value };
